export const LoomRecorderTriggerEvent = {
	CROSS_FLOW_SUCCESS: 'cross-flow-success',
	// Created a separate JSM event trigger to avoid any accidental triggering from other touchpoints
	CROSS_FLOW_SUCCESS_FROM_JSM: 'cross-flow-success-from-jsm',
} as const;

export type LoomRecorderTriggerEventType =
	(typeof LoomRecorderTriggerEvent)[keyof typeof LoomRecorderTriggerEvent];
